import { render, staticRenderFns } from "./TheHomeArgumentsItem.vue?vue&type=template&id=8902c11c"
import script from "./TheHomeArgumentsItem.vue?vue&type=script&lang=js"
export * from "./TheHomeArgumentsItem.vue?vue&type=script&lang=js"
import style0 from "./TheHomeArgumentsItem.vue?vue&type=style&index=0&id=8902c11c&prod&scopes=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports